import { saveOrShareBlob } from '@/lib/nativeFile';
import { estilizarCabecalho, autoWidth } from '@/lib/excelStyle';

/**
 * Modelo .xlsx da importação de cargos (POST /api/cargos/importar). Colunas: nome (obrigatória),
 * quantidade e departamento (opcionais). Regras: docs/importacao-cargos-quadro-2026-10-08.md (seção 4).
 */
export const COLUNAS_IMPORTACAO_CARGOS = ['nome', 'quantidade', 'departamento'];

const INSTRUCOES = [
  'nome: obrigatório. Cargo que já existe (sem diferenciar maiúscula/acento) é atualizado, não duplicado.',
  'quantidade: opcional. Número inteiro de pessoas no quadro (0 a 99999). Usado no organograma quando ninguém cadastrado tem o cargo.',
  'departamento: opcional. Departamento que não existir na empresa é criado (em maiúsculo).',
  'Célula vazia não apaga o que o cargo já tem.',
  'Cargo que está na Lixeira não é importado: restaure-o antes.',
  'Até 500 linhas por arquivo. Formatos: .xlsx ou .csv.',
];

export async function baixarModeloImportacaoCargos(): Promise<void> {
  // Carregado sob demanda: o exceljs só entra quando alguém baixa o modelo.
  const ExcelJS = (await import('exceljs')).default;
  const workbook = new ExcelJS.Workbook();

  const aba = workbook.addWorksheet('Cargos');
  aba.columns = COLUNAS_IMPORTACAO_CARGOS.map((key) => ({ header: key, key }));
  aba.addRow({ nome: 'Separador', quantidade: 10, departamento: 'Operação' });
  aba.addRow({ nome: 'Conferente de Expedição', quantidade: 2, departamento: 'Operação' });
  aba.addRow({ nome: 'Gerente', quantidade: 1, departamento: '' });
  estilizarCabecalho(aba);
  autoWidth(aba, { nome: 28, quantidade: 12, departamento: 18 });

  const instrucoes = workbook.addWorksheet('Instruções');
  instrucoes.columns = [{ header: 'Como preencher', key: 'texto', width: 110 }];
  INSTRUCOES.forEach((texto) => instrucoes.addRow({ texto }));
  estilizarCabecalho(instrucoes);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  await saveOrShareBlob(blob, 'modelo_importacao_cargos.xlsx');
}
